import api from '../../api/api_resource'
import {saveVuexState, getVuexState} from "../../util/common";
const saveState = state => {
    saveVuexState('saved_search_state', state)
}
const state = getVuexState('saved_search_state', {
    all: [],
    current_page: 1,
    per_page: 25,
    from: 1,
    to: 50,
    last_page: null,
    total: null,
    auctions: [],
    scrollTop: 0
});

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    auction: (state, getters, rootState) => {
        return state.auctions;
    },
    scrollTop: state => state.scrollTop
};

let auctionDataPromise;

// actions
const actions = {
    async maybeGetAuctions({ commit, state, dispatch }, args) {
        if (!auctionDataPromise) {
            // if this function is called multiple times we will return the same promise,
            // so the ajax call will only run once.
            auctionDataPromise = dispatch('getAuctions', args);
        }
        return auctionDataPromise;
    },
    async getAuctions({ commit, state }, args){
        let data = await api.get('search.auctions')
        if (data.auctions) {
            commit('setAuctions', data.auctions)
        }
    },
    getAll({ commit, state }, args) {
        const search_args = Object.assign({
            page: state.current_page,
            per_page: state.per_page
        }, args);
        return new Promise((resolve, reject) => {
            api.index('saved-search', search_args).then(result => {
                commit('setSavedSearch', result)
                resolve(result)
            }).catch(reject);
        });
    },
    deleteSearch({ commit, state }, id){
        return new Promise((resolve, reject) => {
            api.destroy('saved-search', id).then(result => {
                commit('removeSearch', id);
                resolve(true);
            }).catch(reject);
        });
    },
    saveSearch({ commit, state }, data){
        console.log('saveSearch', data)
        return new Promise((resolve, reject) => {
            let res;
            if (data.id) {
                res = api.update('saved-search', data, data.id);
            } else {
                res = api.store('saved-search', data);
            }
            res.then(result => {
                resolve(result);
            }).catch(reject);
        });
    }
};

// mutations
const mutations = {
    setSavedSearch (state, result) {
        state.all = result.data;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
        saveState(state)
    },
    removeSearch(state, id) {
        let found = false;
        state.all.forEach((item, index) => {
            if (item.id === id) {
                found = index;
            }
        });
        if (found !== false) {
            state.all.splice(found, 1);
        }
        saveState(state)
    },
    setAuctions(state, auctions){
        state.auctions = auctions
        saveState(state)
    },
    setScrollTop(state, scrollTop) {
        state.scrollTop = scrollTop
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/saved_searches.js